<template>
  <label :for="option.id">
    <span class="tile-title"><span class="icon logo-rituals"></span>{{ option.name }}</span>
    <span class="body-text">
        {{ option.time }}
    </span>
    <span class="store-distance"> {{ option.distance }}</span>
    <a :href="option.directions.url" target="_blank" class="store-maps-link">{{option.directions.title}}</a>
  </label>
</template>
<script src="./click-and-collect-option-tile.js"/>
